/**
 * readingLevel.js — the ONE decision about what reading level the patient chose.
 *
 * ★★★ IT EXISTS BEFORE THE SECOND SCREEN DOES, ON PURPOSE. The Diagnose review shipped
 * this control first with the level, the storage key and the three ids declared inside
 * DiagnoseScreen.jsx. The pre-visit summary is the second screen to want it, and two
 * places is how they drift — the same shape as authStorage.js, and the same reason.
 *
 * ★★ ONE KEY ACROSS BOTH SCREENS IS THE FEATURE, NOT AN ECONOMY. A patient who asked
 * for plainer language at their diagnosis is telling us how they read, not how they
 * read that one document. Asking again on the next screen would be asking them to
 * declare it twice.
 *
 * ★ PER DEVICE, NOT PER ACCOUNT. localStorage, so it does not follow them to a second
 * phone. That is a known limit, not an oversight — moving it to the profile means a
 * schema change and a migration, and is worth doing when something else needs one.
 *
 * ★ NOT authStorage.js. That file owns where AUTH lives and nothing else. This is a UI
 * preference: not PHI, not a credential, and it must survive on web too, where
 * authStorage deliberately uses sessionStorage.
 */

export const READING_LEVELS = ['simpler', 'standard', 'detailed']
export const DEFAULT_READING_LEVEL = 'standard'

const STORAGE_KEY = 'orella_avs_level'

// ★★ AVS-SUMMARY-1 (2026-10-12, Dr. Rami): the reading-level control is removed from the
//   app. With no way left to change it, a stored "simpler" or "detailed" would follow a
//   patient forever, so every reader now gets the standard level. The stored value is ignored,
//   not deleted; storeReadingLevel has no remaining caller.
export function readStoredReadingLevel() {
  return DEFAULT_READING_LEVEL
}


export function storeReadingLevel(level) {
  if (!READING_LEVELS.includes(level)) return
  try { window.localStorage.setItem(STORAGE_KEY, level) } catch { /* private mode */ }
}

